export const formatPlaybackSpeedLabel = (value: number) => `${value}x`
